module.exports = __webpack_public_path__ + "static/img/图层5.9d066fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cardSolution/图层5.png
// module id = xqI+
// module chunks = 0